import { ProjectResources } from '../../domain/backoffice/project/ProjectResources';
import { ProjectResourcesDTO } from '../../domain/backoffice/project/ProjectResourcesDTO';

export class ProjectResourcesMapper {
  static toDomain(raw: ProjectResourcesDTO): ProjectResources {
    const { vehicles, supervisors, max_clients, max_stops_plan, max_vehicles_plan, traffic } = raw;

    return ProjectResources.create({
      vehicles,
      supervisors,
      max_clients,
      max_stops_plan,
      max_vehicles_plan,
      traffic,
    });
  }

  static toDTO(projectResources: ProjectResources): ProjectResourcesDTO {
    return {
      traffic: projectResources.traffic,
      vehicles: projectResources.vehicles,
      max_clients: projectResources.max_clients,
      max_stops_plan: projectResources.max_stops_plan,
      max_vehicles_plan: projectResources.max_vehicles_plan,
      supervisors: projectResources.supervisors,
    };
  }
}
